import { Switch } from "antd";
import moment from "moment";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(page = 1, onChangeState = null) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellido",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Canal",
      dataIndex: "canal",
      key: "canal",
      sorter: (a, b) => a.canal.localeCompare(b.canal),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Modalidad",
      dataIndex: "modalidadingreso",
      key: "modalidadingreso",
      sorter: (a, b) => a.modalidadingreso.localeCompare(b.modalidadingreso),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Asistió",
      dataIndex: "asistio",
      key: "asistio",
      render: (asistio) => {
        if (!asistio) return <p></p>;
        return <p className="font-bold">SÍ</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Día",
      dataIndex: "fechahoraasistio",
      key: "fechahoraasistio",
      render: (fechahoraasistio) => {
        if (!fechahoraasistio) return <p></p>;
        return <p>{moment(fechahoraasistio).format("L")}</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Hora",
      dataIndex: "fechahoraasistio",
      key: "fechahoraasistio",
      render: (fechahoraasistio) => {
        if (!fechahoraasistio) return <p></p>;
        return <p>{moment(fechahoraasistio).format("hh:mm A")}</p>;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Acciones",
      key: "action",
      render: (record) => (
        <Switch size="small" checked={record.activo} onChange={() => onChangeState(record)} />
      )
    }
  ];
}
